'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer';
import { Tag } from '@/components/elementary/Tag';
import { ArrowRight } from '@/components/icons/ArrowRight';
import Heading from '@/components/typography/Heading';
import { Paragraph } from '@/components/typography/Paragraph';
import { formatDate } from '@/lib/dates';
import { CHANGELOG_TEST_IDS } from '@/lib/test-ids';
import type { ServerRenderedEntry } from '@/types/helpers';
export const ChangelogItem = t0 => {
  const $ = _c(30);
  const {
    entryItem
  } = t0;
  const t1 = entryItem?.changeDate ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = formatDate(t1, "MMMM d, yyyy");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const formattedDate = t2;
  let t3;
  if ($[2] !== formattedDate) {
    t3 = <Paragraph className="lg:sticky lg:top-33" fontSize="bodyRegularLarge">{formattedDate}</Paragraph>;
    $[2] = formattedDate;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== entryItem.categories) {
    t4 = entryItem.categories?.map(_temp);
    $[4] = entryItem.categories;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex flex-wrap gap-2 lg:hidden">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="relative flex justify-between items-center min-w-40 pt-1 lg:items-baseline">{t3}{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== entryItem.categories) {
    t7 = entryItem.categories?.map(_temp2);
    $[11] = entryItem.categories;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div className="hidden lg:flex lg:flex-wrap lg:gap-2 lg:mb-4">{t7}</div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== entryItem.title) {
    t9 = entryItem.title && <Heading tag="h2" fontSize="displaySmall" className="mb-6 lg:mb-8">{entryItem.title}</Heading>;
    $[15] = entryItem.title;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== entryItem.htmlContent || $[18] !== entryItem.serverProcessedHtmlContent) {
    t10 = entryItem.serverProcessedHtmlContent ? entryItem.serverProcessedHtmlContent : <CkEditorCSRRenderer htmlContent={entryItem.htmlContent} />;
    $[17] = entryItem.htmlContent;
    $[18] = entryItem.serverProcessedHtmlContent;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== entryItem.link) {
    t11 = entryItem?.link?.href && <AppLink link={entryItem?.link} className="w-fit lok-text-body-bold-medium" iconEnd={<ArrowRight className="size-5.5" />}>{entryItem?.link?.label}</AppLink>;
    $[20] = entryItem.link;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t8 || $[25] !== t9) {
    t12 = <div className="flex-1">{t8}{t9}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t8;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t6) {
    t13 = <div className="flex flex-col gap-3 lg:flex-row lg:gap-12.5 lg:py-14 py-8 border-b border-neutral-light-500 last:border-b-0" data-test-id={CHANGELOG_TEST_IDS.ITEM}>{t6}{t12}</div>;
    $[27] = t12;
    $[28] = t6;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};
function _temp(category) {
  return <Tag key={category.id} name={category?.name} customColors={{
    backgroundColor: category.backgroundColor?.color,
    borderColor: category.borderColor?.color
  }} />;
}
function _temp2(category_0) {
  return <Tag key={category_0.id} name={category_0?.name} customColors={{
    backgroundColor: category_0.backgroundColor?.color,
    borderColor: category_0.borderColor?.color
  }} />;
}